/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
export interface PlusProps extends React.SVGAttributes<SVGElement> {
size?: string;
}
export const Plus: React.SFC<PlusProps> = ({size, ...props}) => (
  <svg viewBox="0 0 16 16" fill="currentColor" width={ size || "16" } height={ size || "16" } {...props}>
    <path fill="currentColor" d="M12.159 7.2h-3.36v-3.36c0-0.442-0.358-0.48-0.8-0.48s-0.8 0.038-0.8 0.48v3.36h-3.359c-0.442 0-0.48 0.358-0.48 0.8s0.038 0.8 0.48 0.8h3.359v3.36c0 0.442 0.358 0.48 0.8 0.48s0.8-0.038 0.8-0.48v-3.36h3.36c0.442 0 0.481-0.358 0.481-0.8s-0.038-0.8-0.481-0.8z"
    />
  </svg>
);
Plus.displayName = 'Plus';
/* tslint:enable */
/* eslint-enable */
